import { ref, onMounted, onUnmounted, type Ref } from 'vue'

/**
 * 检测元素是否进入视口
 * @param options IntersectionObserver 配置
 * @returns isInView: 是否在视口中; targetRef: 需要绑定的模板 ref
 */
export function useInView(options?: IntersectionObserverInit): {
  isInView: Ref<boolean>
  targetRef: Ref<HTMLElement | null>
} {
  const isInView = ref(false)
  const targetRef = ref<HTMLElement | null>(null)

  let observer: IntersectionObserver | null = null

  function observe() {
    if (!targetRef.value) return

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isInView.value = true
            observer?.disconnect()
          }
        })
      },
      { threshold: 0.2, ...options },
    )

    observer.observe(targetRef.value)
  }

  onMounted(() => {
    observe()
  })

  onUnmounted(() => {
    observer?.disconnect()
  })

  return { isInView, targetRef }
}
